module.exports = __webpack_public_path__ + "img/9788934991694.e92aed6c.jpg";